<template>
    <v-card flat>
        <v-row>
            <v-col cols="12" sm="12" class="pt-6">
                <v-form v-model="validated">
                    <v-row class="d-flex align-center">
                        <v-col cols="12" sm="6" class="py-0 px-6 d-flex justify-center text-center">
                            <div>
                                <p class="pa-0 ma-0 caption">{{ $t('companyLogo') }}</p>
                                <img :src="companyImg"  class="company-image my-3"/>
                                <div class="d-flex align-baseline justify-center flex-wrap">
                                    <div class="fl_upld pb-4">
                                        <label>
                                            <input
                                                id="fl_inp"
                                                class="input-image"
                                                type="file"
                                                accept="image/*"
                                                @change=uploadImage
                                            >
                                            {{ $t('selectFile') }}
                                        </label>
                                    </div>
                                    <v-btn
                                            v-if="companyImage"
                                            text
                                            class="text-capitalize"
                                            @click="deleteAvatar"
                                    >
                                        {{ $t('deleteAvatar') }}
                                    </v-btn>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" class="py-0 pt-4 pt-md-0 px-6">
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                            @input="itemChange"
                                            v-model="companyNameRu"
                                            :label="$t('companyNameRu')"
                                            class="pa-0 ma-0"
                                            color="orange lighten-2"
                                            :rules="rules.text"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-text-field
                                            @input="itemChange"
                                            v-model="companyNameUa"
                                            :label="$t('companyNameUa')"
                                            class="pa-0 ma-0"
                                            color="orange lighten-2"
                                            :rules="rules.text"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex">
                        <v-col cols="12" sm="6" class="px-6">
                            <v-text-field
                                    @input="itemChange"
                                    v-model="companyData.address"
                                    :label="$t('addressFact')"
                                    class="pa-0 ma-0"
                                    color="orange lighten-2"
                                    :rules="rules.text"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="px-6">
                            <v-text-field
                                    @input="itemChange"
                                    v-model="companyData.siteLink"
                                    :label="$t('website')"
                                    class="pa-0 ma-0"
                                    color="orange lighten-2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="d-flex">
                        <v-col cols="12" sm="6" class="px-6">
                            <v-text-field
                                    @input="itemChange"
                                    v-model="companyData.email"
                                    label="Email"
                                    class="pa-0 ma-0"
                                    color="orange lighten-2"
                                    :rules="rules.email"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" class="px-6">
                            <v-text-field
                                    @input="itemChange"
                                    v-model="companyData.phone"
                                    :label="$t('telephone')"
                                    class="pa-0 ma-0"
                                    color="orange lighten-2"
                                    :rules="rules.text"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12" class="px-6">
                            <div>
                                <v-card-title class="subtitle-2 ">{{ $t('companyDescriptionRu') }}</v-card-title>
                                <ckeditor
                                        @input="itemChange"
                                        :editor="editor"
                                        v-model="descriptionRu"
                                        :config="editorConfig"
                                        class="border-transparent"
                                        :rules="rules.text"
                                ></ckeditor>
                            </div>
                            <div>
                                <v-card-title class="subtitle-2 ">{{ $t('companyDescriptionUa') }}</v-card-title>
                                <ckeditor
                                        @input="itemChange"
                                        :editor="editor"
                                        v-model="descriptionUa"
                                        :config="editorConfig"
                                        class="border-transparent"
                                        :rules="rules.text"
                                ></ckeditor>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <snack-general :snack-data="snackData"></snack-general>
        <v-snackbar
                color="main--black"
                dark
                v-model="snackOpen"
                top
        >
            {{ $t('avatarDeleted') }}
        </v-snackbar>
    </v-card>
</template>

<script>

    import AvatarEdit from '../../../../app-front/components/profile/avatar-edit';
    import AppSnack from '../../../../general/mixins/AppSnack';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import '@ckeditor/ckeditor5-build-classic/build/translations/ru';
    import CompanyService from '../../../../app-front/services/api/CompanyService';
    import SnackGeneral from '../../../../app-front/components/snacks/SnackGeneral';

    export default {
        name: "MainCompanyInfo",
        components:{AvatarEdit, SnackGeneral},
        mixins:[AppSnack],
        props: ['initialCompanyData'],
        data() {
            return {
                validated: false,
                rules: {
                    email: [
                        v => !!v || this.$t('emailRequired'),
                        v => /.+@.+/.test(v) || this.$t('emailInvalid'),
                    ],
                    text: [
                        v => !!v || this.$t('requiredField')
                    ],
                },
                companyData: {
                    address: null,
                    email: null,
                    phone: null,
                    siteLink: null,
                    langs: [],
                    image: {},
                },
                companyNameRu: null,
                companyNameUa: null,
                editor: ClassicEditor,
                descriptionRu: '',
                descriptionUa: '',
                editorConfig: {
                    language: 'ru',
                    label: this.$t('description'),
                },
                companyImage: null,
                defaultLangs: [{languageId: 1}, {languageId: 2}],
                snackData: {
                    isOpen: false,
                    color: '',
                    text: ''
                },
                result: {
                    css: '',
                    header: '',
                    id: null
                },
            }
        },
        computed: {
            companyImg() {
                return  this.companyImage || '/images/default-user.png';
            }
        },
        methods: {
            deleteAvatar() {
                CompanyService.deleteAvatar({image: null})
                    .then(res => {
                        this.result.css = 'success';
                        this.result.header = this.$t('avatarDeleted');
                        this.openSnack();
                        this.companyImage = null;
                    })
                    .catch(err => {
                        this.result.css = 'error';
                        this.result.header = this.$t('changesSavedError');
                        console.log(err.data);
                    });
            },
            companyAvatar() {
                if (this.companyData.image) {
                    this.companyImage = this.companyData.image.url;
                }
            },
            companyDescription() {
                if (this.companyData.langs) {
                    this.descriptionRu = this.companyData.langs[0].description;
                    this.descriptionUa = this.companyData.langs[1].description;
                }
            },
            companyName() {
                if (this.companyData.langs) {
                    this.companyNameRu = this.companyData.langs[0].name;
                    this.companyNameUa = this.companyData.langs[1].name;
                }
            },
            itemChange() {
                if(!this.companyData.langs) {
                    this.companyData.langs = this.defaultLangs;
                }

                if (this.companyNameRu) {
                    this.companyData.langs[0].name = this.companyNameRu;
                }
                if (this.companyNameUa) {
                    this.companyData.langs[1].name = this.companyNameUa;
                }
                if (this.descriptionRu) {
                    this.companyData.langs[0].description = this.descriptionRu;
                }
                if (this.descriptionUa) {
                    this.companyData.langs[1].description = this.descriptionUa;
                }

                const data = this.companyData;
                let isValid = true;

                if (!this.validate(data)) {
                    isValid = false;
                }

                this.$emit('list-change', {data, isValid});
            },
            snackHandle(text, color, isOpen) {
                this.snackData.color = color;
                this.snackData.text = text;
                this.snackData.isOpen = isOpen;
            },
            validate(company) {
                let valid = false;

                if(company.address && company.email && company.phone && company.langs.length) {
                    valid = true;
                } else {
                    valid = false;
                }

                return valid;
            },
            uploadImage(e){
                const image = e.target.files[0];

                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                    this.companyImage = e.target.result;
                };

                const formData = new FormData();
                formData.append("image", image);

                CompanyService.saveImage(formData)
                    .then(
                        this.snackHandle(this.$t('changesSaved'), 'main--black', true),
                    )
                    .catch(err => {
                        this.snackHandle(this.$t('changesSavedError'), 'error', true);
                        console.log(err);
                    })
            },
        },
        beforeMount() {
            this.companyData = this.initialCompanyData;
        },
        watch: {
            initialCompanyData: {
                handler() {
                    if(Object.keys(this.initialCompanyData).length) {
                        this.companyData = this.initialCompanyData;
                    }
                    this.companyName();
                    this.companyDescription();
                    this.companyAvatar();
                },
                deep: true
            },
        }
    }
</script>

<style scoped>
    .company-image {
        border:1px solid #F5B821;
        background: #fff;
        width: 150px;
        height: 150px;
        object-fit: contain;
        border-radius: 50%;
    }
    #fl_inp {
        display:none;
    }
    .fl_upld label {
        cursor: pointer;
        padding: 10px 25px;
        color: #F5B821;
        text-align: center;
    }

</style>
